<nz-layout>
  <nz-header>
    <span class="section-header">{{ "Pregnancy" | translate }}</span>
  </nz-header>
  <nz-content>
    <app-pregnancy-history />
    <app-pregnancy-status />
    <app-pregnancy-outcome />
  </nz-content>
</nz-layout>
